<div class="padding p_re">
    <div>
        <div class="left-align">
            <p name="createUser" class="filter-action">
                <img class="icon-edit cursor-pointer flex-item" src="assets/images/filter.png" alt="filter" />
                Filters
            </p>
        </div>
        <div class="right-align p-r-10">
            <button type="button" name="createUser" class="close-action" (click)="closeDialog()">
                Close
            </button>
        </div>
    </div>
    <div class="clear-filter cursor-pointer" [hidden]="!isSubmitted" (click)="clearFilters()">
        <p>Clear Filters</p>
    </div>
    <div class="pull-down">
        <form [formGroup]='filterLeadForm'>
            <div>
                <mat-form-field appearance="fill" class="width_100 pr-20">
                    <mat-label class="fn_h">Date Range</mat-label>
                    <mat-date-range-input [rangePicker]="picker" [max]="maxDate">
                        <input matStartDate placeholder="Start date" formControlName="fromDate"
                            (dateChange)="startChange($event)">
                        <input matEndDate placeholder="End date" formControlName="toDate"
                            (dateChange)="endChange($event)">
                    </mat-date-range-input>
                    <mat-datepicker-toggle matPrefix [for]="picker"></mat-datepicker-toggle>
                    <mat-date-range-picker #picker></mat-date-range-picker>
                </mat-form-field>
            </div>
            <div class="row m_bt_20 mr-20">
                <div class="col-md-4" *ngFor="let tool of tools">
                    <button [class]="tool.class" (click)="handleClick(tool)">
                        <span> {{tool.click}}</span>
                    </button>
                </div>
            </div>
            <div class='contentWidth'>
                <label class="fn_h">
                    Lead Age
                </label>
                <div class="col-sm-12 row ">
                    <div class="col-sm-4 p-0 m_bt_20" *ngFor="let item of leadAge">
                        <mat-checkbox [checked]="item.checked" (change)="showOptions($event,item)" [value]="item.id">
                            <span class='mat-checkbox-label'> {{item.days}}
                            </span></mat-checkbox>
                        <br />
                    </div>
                </div>
            </div>
            <div>
                <label class="fn_h">User</label>
                <ng-select [items]="users" bindLabel="userid" bindValue="userid" dropdownPosition="top"
                    formControlName='user' (change)="userSelection($event)" placeholder="Select User...."
                    [multiple]="true" [searchable]="true" (clear)="clearUser()" (remove)="removeUser($event)"
                    #selectOwner>
                    <ng-template ng-option-tmp let-item="item">
                        <div title="{{item.userid}}">{{item.userid}}</div>
                    </ng-template>
                </ng-select>
            </div>
            <div class="p-t">
                <label class="fn_h">Pincode</label>
                <ng-select class="m_bt_20" [items]="options" (change)="pincodeSelection($event)" bindLabel="pincode"
                    bindValue="pincode" dropdownPosition="top" formControlName='pincode' (keyup)="pincodeSearch($event)"
                    placeholder="Search Pin Code...." (clear)="clearPincode()" (remove)="removePincode($event)"
                    [multiple]="true" [searchable]="true" #selectOwner>
                    <ng-template ng-option-tmp let-item="item">
                        <div title="{{item.pincode}}">{{item.pincode}}</div>
                    </ng-template>
                </ng-select>
                <!-- <ng-select [searchable]="true" (change)="pincodeSelection($event)" formControlName='pincode'
                    (keyup)="pincodeSearch($event)" placeholder="Search Pin Code....">
                    <ng-option *ngFor="let item of options" [value]="item.pincode">{{item.pincode}}</ng-option>
                </ng-select> -->
            </div>
        </form>
    </div>
    <div class="display-leadscount" *ngIf="totalUsers!=null">
        <p *ngIf="totalUsers>=1">
            {{totalUsers}} Leads Found
        </p>
        <p *ngIf="totalUsers==0 ">
            No Leads Found
        </p>
    </div>
</div>